var React = require('react');

function SectionBreakBottom (props) {
    return React.createElement("svg",props,React.createElement("clipPath",{"id":"section-break-bottom","clipPathUnits":"objectBoundingBox"},React.createElement("path",{"d":"M0 0 V1 c 0.2 -0.05, 0.3 -0.05, 0.5 -0.025 s 0.3 0.05, 0.5 -0.025 V0 Z"})));
}

SectionBreakBottom.defaultProps = {"width":"0","height":"0","version":"1.1"};

module.exports = SectionBreakBottom;

SectionBreakBottom.default = SectionBreakBottom;
